import React, { ReactNode } from 'react';
import cx from 'classnames';

import './Modal.css';

interface ModalProps {
  isShown: boolean;
  isSmall?: boolean;
  children: ReactNode;
}

class Modal extends React.PureComponent<ModalProps> {
  render(): React.ReactElement | null {
    const {
      children,
      isShown,
      isSmall,
    } = this.props;

    if (!isShown) {
      return null;
    }

    return (
      <div className="modal-wrapper">
        <div
          id="modal-window"
          className={cx('modal', {
            'modal-sm': isSmall,
          })}
        >
          { children }
        </div>
      </div>
    );
  }
}

export default Modal;
